
import '../styles/contacto.css'
import whats from '../assets/whatsapp.jpg'
import correo from '../assets/correo.png'

function Contacto(){
    return(
        <div>
            <div className="titulo-contacto">
                <h2>Agradecemos que te pongas en contacto por algunas de nuestras redes, con mucho gusto responderemos lo mas rápido posible.</h2>
                <p>Los números y correos proporcionados aqui son los oficiales.</p>
            </div>
            <div className="whats">
                <p>Mandanos mensaje haciendo click en la imagen o mandamos mensaje al número +52 2215301249 o llamanos al número 2222710102 .</p>
                <a
                    href="https://wa.me/522215301249?text=Hola,%20quiero%20más%20información%20sobre%20sus%20productos"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={whats} alt="Contáctanos por whatsapp" style={{cursor: 'pointer'}} />
                </a>
            </div>
            <br />
            <div className="correo">
                <p>Con gusto te atenderemos en nuestro correo electrónico</p>
                <p>jugueteriamago@outlook.com</p>
                <img src={correo} alt="Contáctanos por correo" />
                
            </div>
            <br />
            <div className="horario">
                <p>Te esperamos todos los dias del año excepto días festivos en un horario de :</p>
                <p><strong>9:00 a.m a 7:00 p.m</strong></p>
            </div>
            <div className="despedida">
                <h2>Juguetería Mago, tu fé hecho arte.</h2>
            </div>
        </div>
    )
}

export default Contacto